const SensorSuccessIcon = ({ className, title }) => (
  <svg
    aria-hidden={title ? undefined : 'true'}
    className={className}
    fill='none'
    height='23'
    role={title ? 'img' : undefined}
    viewBox='0 0 23 23'
    width='23'
    xmlns='http://www.w3.org/2000/svg'
  >
    {title && <title>{title}</title>}
    <circle
      cx='11.5'
      cy='11.5'
      r='10.75'
      stroke='#05CE91'
      strokeWidth='1.5'
    />
    <path
      d='M6.65 11.5L9.65 14.5L16.35 8.25'
      stroke='#05CE91'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
  </svg>
)

export default SensorSuccessIcon
